'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _antd = require('@adparlor-devops/antd');

var _reactIntl = require('react-intl');

var _Condition = require('./Condition');

var _Condition2 = _interopRequireDefault(_Condition);

require('./ConditionGroup.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioButton = _antd.Radio.Button;
var RadioGroup = _antd.Radio.Group;

var conditionGroupQuantifierLabels = {
  ALL: _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'conditiongroup.quantifier.button.all',
    defaultMessage: 'AND'
  }),
  ANY: _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'conditiongroup.quantifier.button.any',
    defaultMessage: 'OR'
  })
};

var ConditionGroup = (_temp2 = _class = function (_React$Component) {
  (0, _inherits3.default)(ConditionGroup, _React$Component);

  function ConditionGroup() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ConditionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ConditionGroup.__proto__ || (0, _getPrototypeOf2.default)(ConditionGroup)).call.apply(_ref, [this].concat(args))), _this), _this.updateConditionGroupQuantifier = function (id, ruleBranchID) {
      return function (e) {
        _this.props.conditionGroupActions.update(id, ruleBranchID, {
          quantifier: e.target.value
        });
      };
    }, _this.renderConditions = function () {
      var _this$props = _this.props,
          conditionGroup = _this$props.conditionGroup,
          ruleBranchID = _this$props.ruleBranchID,
          conditionActions = _this$props.conditionActions,
          editingConditions = _this$props.editingConditions,
          ruleSettings = _this$props.ruleSettings;

      if (conditionGroup.conditions && conditionGroup.conditions.length) {
        var quantifierLabel = _react2.default.createElement(
          'div',
          { className: 'condition-group-quantifier' },
          conditionGroupQuantifierLabels[conditionGroup.quantifier]
        );
        return conditionGroup.conditions.map(function (condition, index) {
          var editMode = editingConditions.includes(condition.id);
          return _react2.default.createElement(
            'div',
            { key: 'condition-' + condition.id },
            _react2.default.createElement(_Condition2.default, {
              condition: condition,
              conditionGroupID: conditionGroup.id,
              ruleBranchID: ruleBranchID,
              conditionActions: conditionActions,
              meta: _this.props.meta,
              editing: editMode,
              builderActions: _this.props.builderActions,
              ruleSettings: ruleSettings
            }),
            conditionGroup.conditions[index + 1] && quantifierLabel
          );
        });
      }
      return null;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ConditionGroup, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.props.editingConditions !== nextProps.editingConditions || this.props.conditionGroup !== nextProps.conditionGroup || this.props.meta !== nextProps.meta || this.props.ruleSettings !== nextProps.ruleSettings || this.state !== nextState;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          conditionGroup = _props.conditionGroup,
          ruleBranchID = _props.ruleBranchID;

      return _react2.default.createElement(
        'div',
        { key: 'condition-group-' + conditionGroup.id, className: 'conditionGroup__component' },
        _react2.default.createElement(
          _antd.Row,
          { className: 'condition-group-actions' },
          _react2.default.createElement(
            _antd.Col,
            { span: 24 },
            _react2.default.createElement(
              RadioGroup,
              {
                onChange: this.updateConditionGroupQuantifier(conditionGroup.id, ruleBranchID),
                value: conditionGroup.quantifier,
                className: 'condition-group-quantifier-button'
              },
              _react2.default.createElement(
                RadioButton,
                { value: 'ALL' },
                conditionGroupQuantifierLabels.ALL
              ),
              _react2.default.createElement(
                RadioButton,
                { value: 'ANY' },
                conditionGroupQuantifierLabels.ANY
              )
            ),
            _react2.default.createElement(
              _antd.Tooltip,
              {
                placement: 'top',
                title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'conditiongroup.quantifier.tooltip',
                  defaultMessage: 'Choose how conditions in this group will be combined together'
                })
              },
              _react2.default.createElement(_antd.Icon, { type: 'info-circle-o' })
            )
          )
        ),
        _react2.default.createElement(
          _antd.Row,
          null,
          _react2.default.createElement(
            _antd.Col,
            { span: 24 },
            this.renderConditions()
          )
        ),
        _react2.default.createElement(
          _antd.Row,
          null,
          _react2.default.createElement(
            _antd.Col,
            { span: 24 },
            _react2.default.createElement(
              _antd.Button,
              {
                onClick: function onClick() {
                  _this2.props.conditionActions.add(conditionGroup.id, ruleBranchID);
                },
                type: 'dashed',
                className: 'add-condition-button',
                size: 'small'
              },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'conditiongroup.add.condition.button',
                defaultMessage: '+ Add Condition'
              })
            )
          )
        )
      );
    }
  }]);
  return ConditionGroup;
}(_react2.default.Component), _class.propTypes = {
  conditionGroupActions: _propTypes2.default.shape({
    update: _propTypes2.default.func.isRequired
  }).isRequired,
  conditionActions: _propTypes2.default.shape(_Condition2.default.propTypes.conditionActions).isRequired,
  conditionGroup: _propTypes2.default.shape({
    id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
    quantifier: _propTypes2.default.oneOf(['ALL', 'ANY']).isRequired,
    conditions: _propTypes2.default.arrayOf(_Condition2.default.propTypes.condition)
  }),
  ruleBranchID: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  editingConditions: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])).isRequired,
  meta: _propTypes2.default.shape(_Condition2.default.propTypes.meta).isRequired,
  builderActions: _propTypes2.default.func.isRequired,
  ruleSettings: _propTypes2.default.shape(_Condition2.default.propTypes.ruleSettings).isRequired
}, _class.defaultProps = {
  conditionGroup: {}
}, _temp2);
exports.default = ConditionGroup;


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/majesty/lib/components/core/Builder/components/ConditionGroup.js
// module id = 3783
// module chunks = 4